var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleAbstract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 573,
    height: 313,
    viewBox: "0 0 573 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-abstract"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle1",
    d: "M13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2",
    d: "M53 6.5C53 10.0899 50.0899 13 46.5 13C42.9101 13 40 10.0899 40 6.5C40 2.91015 42.9101 0 46.5 0C50.0899 0 53 2.91015 53 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_2",
    d: "M93 6.5C93 10.0899 90.0899 13 86.5 13C82.9101 13 80 10.0899 80 6.5C80 2.91015 82.9101 0 86.5 0C90.0899 0 93 2.91015 93 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_2",
    d: "M133 6.5C133 10.0899 130.09 13 126.5 13C122.91 13 120 10.0899 120 6.5C120 2.91015 122.91 0 126.5 0C130.09 0 133 2.91015 133 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_3",
    d: "M173 6.5C173 10.0899 170.09 13 166.5 13C162.91 13 160 10.0899 160 6.5C160 2.91015 162.91 0 166.5 0C170.09 0 173 2.91015 173 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_3",
    d: "M213 6.5C213 10.0899 210.09 13 206.5 13C202.91 13 200 10.0899 200 6.5C200 2.91015 202.91 0 206.5 0C210.09 0 213 2.91015 213 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_4",
    d: "M253 6.5C253 10.0899 250.09 13 246.5 13C242.91 13 240 10.0899 240 6.5C240 2.91015 242.91 0 246.5 0C250.09 0 253 2.91015 253 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_4",
    d: "M293 6.5C293 10.0899 290.09 13 286.5 13C282.91 13 280 10.0899 280 6.5C280 2.91015 282.91 0 286.5 0C290.09 0 293 2.91015 293 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_5",
    d: "M333 6.5C333 10.0899 330.09 13 326.5 13C322.91 13 320 10.0899 320 6.5C320 2.91015 322.91 0 326.5 0C330.09 0 333 2.91015 333 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_5",
    d: "M373 6.5C373 10.0899 370.09 13 366.5 13C362.91 13 360 10.0899 360 6.5C360 2.91015 362.91 0 366.5 0C370.09 0 373 2.91015 373 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_6",
    d: "M413 6.5C413 10.0899 410.09 13 406.5 13C402.91 13 400 10.0899 400 6.5C400 2.91015 402.91 0 406.5 0C410.09 0 413 2.91015 413 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_6",
    d: "M453 6.5C453 10.0899 450.09 13 446.5 13C442.91 13 440 10.0899 440 6.5C440 2.91015 442.91 0 446.5 0C450.09 0 453 2.91015 453 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_7",
    d: "M493 6.5C493 10.0899 490.09 13 486.5 13C482.91 13 480 10.0899 480 6.5C480 2.91015 482.91 0 486.5 0C490.09 0 493 2.91015 493 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_7",
    d: "M533 6.5C533 10.0899 530.09 13 526.5 13C522.91 13 520 10.0899 520 6.5C520 2.91015 522.91 0 526.5 0C530.09 0 533 2.91015 533 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_8",
    d: "M573 6.5C573 10.0899 570.09 13 566.5 13C562.91 13 560 10.0899 560 6.5C560 2.91015 562.91 0 566.5 0C570.09 0 573 2.91015 573 6.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_8",
    d: "M13 36.5C13 40.0899 10.0899 43 6.5 43C2.91015 43 0 40.0899 0 36.5C0 32.9101 2.91015 30 6.5 30C10.0899 30 13 32.9101 13 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_9",
    d: "M53 36.5C53 40.0899 50.0899 43 46.5 43C42.9101 43 40 40.0899 40 36.5C40 32.9101 42.9101 30 46.5 30C50.0899 30 53 32.9101 53 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_9",
    d: "M93 36.5C93 40.0899 90.0899 43 86.5 43C82.9101 43 80 40.0899 80 36.5C80 32.9101 82.9101 30 86.5 30C90.0899 30 93 32.9101 93 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_10",
    d: "M133 36.5C133 40.0899 130.09 43 126.5 43C122.91 43 120 40.0899 120 36.5C120 32.9101 122.91 30 126.5 30C130.09 30 133 32.9101 133 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_10",
    d: "M173 36.5C173 40.0899 170.09 43 166.5 43C162.91 43 160 40.0899 160 36.5C160 32.9101 162.91 30 166.5 30C170.09 30 173 32.9101 173 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_11",
    d: "M213 36.5C213 40.0899 210.09 43 206.5 43C202.91 43 200 40.0899 200 36.5C200 32.9101 202.91 30 206.5 30C210.09 30 213 32.9101 213 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_11",
    d: "M253 36.5C253 40.0899 250.09 43 246.5 43C242.91 43 240 40.0899 240 36.5C240 32.9101 242.91 30 246.5 30C250.09 30 253 32.9101 253 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_12",
    d: "M293 36.5C293 40.0899 290.09 43 286.5 43C282.91 43 280 40.0899 280 36.5C280 32.9101 282.91 30 286.5 30C290.09 30 293 32.9101 293 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_12",
    d: "M333 36.5C333 40.0899 330.09 43 326.5 43C322.91 43 320 40.0899 320 36.5C320 32.9101 322.91 30 326.5 30C330.09 30 333 32.9101 333 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_13",
    d: "M373 36.5C373 40.0899 370.09 43 366.5 43C362.91 43 360 40.0899 360 36.5C360 32.9101 362.91 30 366.5 30C370.09 30 373 32.9101 373 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_13",
    d: "M413 36.5C413 40.0899 410.09 43 406.5 43C402.91 43 400 40.0899 400 36.5C400 32.9101 402.91 30 406.5 30C410.09 30 413 32.9101 413 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_14",
    d: "M453 36.5C453 40.0899 450.09 43 446.5 43C442.91 43 440 40.0899 440 36.5C440 32.9101 442.91 30 446.5 30C450.09 30 453 32.9101 453 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_14",
    d: "M493 36.5C493 40.0899 490.09 43 486.5 43C482.91 43 480 40.0899 480 36.5C480 32.9101 482.91 30 486.5 30C490.09 30 493 32.9101 493 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_15",
    d: "M533 36.5C533 40.0899 530.09 43 526.5 43C522.91 43 520 40.0899 520 36.5C520 32.9101 522.91 30 526.5 30C530.09 30 533 32.9101 533 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_15",
    d: "M573 36.5C573 40.0899 570.09 43 566.5 43C562.91 43 560 40.0899 560 36.5C560 32.9101 562.91 30 566.5 30C570.09 30 573 32.9101 573 36.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_16",
    d: "M13 66.5C13 70.0899 10.0899 73 6.5 73C2.91015 73 0 70.0899 0 66.5C0 62.9101 2.91015 60 6.5 60C10.0899 60 13 62.9101 13 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_16",
    d: "M53 66.5C53 70.0899 50.0899 73 46.5 73C42.9101 73 40 70.0899 40 66.5C40 62.9101 42.9101 60 46.5 60C50.0899 60 53 62.9101 53 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_17",
    d: "M93 66.5C93 70.0899 90.0899 73 86.5 73C82.9101 73 80 70.0899 80 66.5C80 62.9101 82.9101 60 86.5 60C90.0899 60 93 62.9101 93 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_17",
    d: "M133 66.5C133 70.0899 130.09 73 126.5 73C122.91 73 120 70.0899 120 66.5C120 62.9101 122.91 60 126.5 60C130.09 60 133 62.9101 133 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_18",
    d: "M173 66.5C173 70.0899 170.09 73 166.5 73C162.91 73 160 70.0899 160 66.5C160 62.9101 162.91 60 166.5 60C170.09 60 173 62.9101 173 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_18",
    d: "M213 66.5C213 70.0899 210.09 73 206.5 73C202.91 73 200 70.0899 200 66.5C200 62.9101 202.91 60 206.5 60C210.09 60 213 62.9101 213 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_19",
    d: "M253 66.5C253 70.0899 250.09 73 246.5 73C242.91 73 240 70.0899 240 66.5C240 62.9101 242.91 60 246.5 60C250.09 60 253 62.9101 253 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_19",
    d: "M293 66.5C293 70.0899 290.09 73 286.5 73C282.91 73 280 70.0899 280 66.5C280 62.9101 282.91 60 286.5 60C290.09 60 293 62.9101 293 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_20",
    d: "M333 66.5C333 70.0899 330.09 73 326.5 73C322.91 73 320 70.0899 320 66.5C320 62.9101 322.91 60 326.5 60C330.09 60 333 62.9101 333 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_20",
    d: "M373 66.5C373 70.0899 370.09 73 366.5 73C362.91 73 360 70.0899 360 66.5C360 62.9101 362.91 60 366.5 60C370.09 60 373 62.9101 373 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_21",
    d: "M413 66.5C413 70.0899 410.09 73 406.5 73C402.91 73 400 70.0899 400 66.5C400 62.9101 402.91 60 406.5 60C410.09 60 413 62.9101 413 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_21",
    d: "M453 66.5C453 70.0899 450.09 73 446.5 73C442.91 73 440 70.0899 440 66.5C440 62.9101 442.91 60 446.5 60C450.09 60 453 62.9101 453 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_22",
    d: "M493 66.5C493 70.0899 490.09 73 486.5 73C482.91 73 480 70.0899 480 66.5C480 62.9101 482.91 60 486.5 60C490.09 60 493 62.9101 493 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_22",
    d: "M533 66.5C533 70.0899 530.09 73 526.5 73C522.91 73 520 70.0899 520 66.5C520 62.9101 522.91 60 526.5 60C530.09 60 533 62.9101 533 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_23",
    d: "M573 66.5C573 70.0899 570.09 73 566.5 73C562.91 73 560 70.0899 560 66.5C560 62.9101 562.91 60 566.5 60C570.09 60 573 62.9101 573 66.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_23",
    d: "M13 96.5C13 100.09 10.0899 103 6.5 103C2.91015 103 0 100.09 0 96.5C0 92.9101 2.91015 90 6.5 90C10.0899 90 13 92.9101 13 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_24",
    d: "M53 96.5C53 100.09 50.0899 103 46.5 103C42.9101 103 40 100.09 40 96.5C40 92.9101 42.9101 90 46.5 90C50.0899 90 53 92.9101 53 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_24",
    d: "M93 96.5C93 100.09 90.0899 103 86.5 103C82.9101 103 80 100.09 80 96.5C80 92.9101 82.9101 90 86.5 90C90.0899 90 93 92.9101 93 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_25",
    d: "M133 96.5C133 100.09 130.09 103 126.5 103C122.91 103 120 100.09 120 96.5C120 92.9101 122.91 90 126.5 90C130.09 90 133 92.9101 133 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_25",
    d: "M173 96.5C173 100.09 170.09 103 166.5 103C162.91 103 160 100.09 160 96.5C160 92.9101 162.91 90 166.5 90C170.09 90 173 92.9101 173 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_26",
    d: "M213 96.5C213 100.09 210.09 103 206.5 103C202.91 103 200 100.09 200 96.5C200 92.9101 202.91 90 206.5 90C210.09 90 213 92.9101 213 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_26",
    d: "M253 96.5C253 100.09 250.09 103 246.5 103C242.91 103 240 100.09 240 96.5C240 92.9101 242.91 90 246.5 90C250.09 90 253 92.9101 253 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_27",
    d: "M293 96.5C293 100.09 290.09 103 286.5 103C282.91 103 280 100.09 280 96.5C280 92.9101 282.91 90 286.5 90C290.09 90 293 92.9101 293 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_27",
    d: "M333 96.5C333 100.09 330.09 103 326.5 103C322.91 103 320 100.09 320 96.5C320 92.9101 322.91 90 326.5 90C330.09 90 333 92.9101 333 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_28",
    d: "M373 96.5C373 100.09 370.09 103 366.5 103C362.91 103 360 100.09 360 96.5C360 92.9101 362.91 90 366.5 90C370.09 90 373 92.9101 373 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_28",
    d: "M413 96.5C413 100.09 410.09 103 406.5 103C402.91 103 400 100.09 400 96.5C400 92.9101 402.91 90 406.5 90C410.09 90 413 92.9101 413 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_29",
    d: "M453 96.5C453 100.09 450.09 103 446.5 103C442.91 103 440 100.09 440 96.5C440 92.9101 442.91 90 446.5 90C450.09 90 453 92.9101 453 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_29",
    d: "M493 96.5C493 100.09 490.09 103 486.5 103C482.91 103 480 100.09 480 96.5C480 92.9101 482.91 90 486.5 90C490.09 90 493 92.9101 493 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_30",
    d: "M533 96.5C533 100.09 530.09 103 526.5 103C522.91 103 520 100.09 520 96.5C520 92.9101 522.91 90 526.5 90C530.09 90 533 92.9101 533 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_30",
    d: "M573 96.5C573 100.09 570.09 103 566.5 103C562.91 103 560 100.09 560 96.5C560 92.9101 562.91 90 566.5 90C570.09 90 573 92.9101 573 96.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_31",
    d: "M13 126.5C13 130.09 10.0899 133 6.5 133C2.91015 133 0 130.09 0 126.5C0 122.91 2.91015 120 6.5 120C10.0899 120 13 122.91 13 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_31",
    d: "M53 126.5C53 130.09 50.0899 133 46.5 133C42.9101 133 40 130.09 40 126.5C40 122.91 42.9101 120 46.5 120C50.0899 120 53 122.91 53 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_32",
    d: "M93 126.5C93 130.09 90.0899 133 86.5 133C82.9101 133 80 130.09 80 126.5C80 122.91 82.9101 120 86.5 120C90.0899 120 93 122.91 93 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_32",
    d: "M133 126.5C133 130.09 130.09 133 126.5 133C122.91 133 120 130.09 120 126.5C120 122.91 122.91 120 126.5 120C130.09 120 133 122.91 133 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_33",
    d: "M173 126.5C173 130.09 170.09 133 166.5 133C162.91 133 160 130.09 160 126.5C160 122.91 162.91 120 166.5 120C170.09 120 173 122.91 173 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_33",
    d: "M213 126.5C213 130.09 210.09 133 206.5 133C202.91 133 200 130.09 200 126.5C200 122.91 202.91 120 206.5 120C210.09 120 213 122.91 213 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_34",
    d: "M253 126.5C253 130.09 250.09 133 246.5 133C242.91 133 240 130.09 240 126.5C240 122.91 242.91 120 246.5 120C250.09 120 253 122.91 253 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_34",
    d: "M293 126.5C293 130.09 290.09 133 286.5 133C282.91 133 280 130.09 280 126.5C280 122.91 282.91 120 286.5 120C290.09 120 293 122.91 293 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_35",
    d: "M333 126.5C333 130.09 330.09 133 326.5 133C322.91 133 320 130.09 320 126.5C320 122.91 322.91 120 326.5 120C330.09 120 333 122.91 333 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_35",
    d: "M373 126.5C373 130.09 370.09 133 366.5 133C362.91 133 360 130.09 360 126.5C360 122.91 362.91 120 366.5 120C370.09 120 373 122.91 373 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_36",
    d: "M413 126.5C413 130.09 410.09 133 406.5 133C402.91 133 400 130.09 400 126.5C400 122.91 402.91 120 406.5 120C410.09 120 413 122.91 413 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_36",
    d: "M453 126.5C453 130.09 450.09 133 446.5 133C442.91 133 440 130.09 440 126.5C440 122.91 442.91 120 446.5 120C450.09 120 453 122.91 453 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_37",
    d: "M493 126.5C493 130.09 490.09 133 486.5 133C482.91 133 480 130.09 480 126.5C480 122.91 482.91 120 486.5 120C490.09 120 493 122.91 493 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_37",
    d: "M533 126.5C533 130.09 530.09 133 526.5 133C522.91 133 520 130.09 520 126.5C520 122.91 522.91 120 526.5 120C530.09 120 533 122.91 533 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_38",
    d: "M573 126.5C573 130.09 570.09 133 566.5 133C562.91 133 560 130.09 560 126.5C560 122.91 562.91 120 566.5 120C570.09 120 573 122.91 573 126.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_38",
    d: "M13 156.5C13 160.09 10.0899 163 6.5 163C2.91015 163 0 160.09 0 156.5C0 152.91 2.91015 150 6.5 150C10.0899 150 13 152.91 13 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_39",
    d: "M53 156.5C53 160.09 50.0899 163 46.5 163C42.9101 163 40 160.09 40 156.5C40 152.91 42.9101 150 46.5 150C50.0899 150 53 152.91 53 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_39",
    d: "M93 156.5C93 160.09 90.0899 163 86.5 163C82.9101 163 80 160.09 80 156.5C80 152.91 82.9101 150 86.5 150C90.0899 150 93 152.91 93 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_40",
    d: "M133 156.5C133 160.09 130.09 163 126.5 163C122.91 163 120 160.09 120 156.5C120 152.91 122.91 150 126.5 150C130.09 150 133 152.91 133 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_40",
    d: "M173 156.5C173 160.09 170.09 163 166.5 163C162.91 163 160 160.09 160 156.5C160 152.91 162.91 150 166.5 150C170.09 150 173 152.91 173 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_41",
    d: "M213 156.5C213 160.09 210.09 163 206.5 163C202.91 163 200 160.09 200 156.5C200 152.91 202.91 150 206.5 150C210.09 150 213 152.91 213 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_41",
    d: "M253 156.5C253 160.09 250.09 163 246.5 163C242.91 163 240 160.09 240 156.5C240 152.91 242.91 150 246.5 150C250.09 150 253 152.91 253 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_42",
    d: "M293 156.5C293 160.09 290.09 163 286.5 163C282.91 163 280 160.09 280 156.5C280 152.91 282.91 150 286.5 150C290.09 150 293 152.91 293 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_42",
    d: "M333 156.5C333 160.09 330.09 163 326.5 163C322.91 163 320 160.09 320 156.5C320 152.91 322.91 150 326.5 150C330.09 150 333 152.91 333 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_43",
    d: "M373 156.5C373 160.09 370.09 163 366.5 163C362.91 163 360 160.09 360 156.5C360 152.91 362.91 150 366.5 150C370.09 150 373 152.91 373 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_43",
    d: "M413 156.5C413 160.09 410.09 163 406.5 163C402.91 163 400 160.09 400 156.5C400 152.91 402.91 150 406.5 150C410.09 150 413 152.91 413 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_44",
    d: "M453 156.5C453 160.09 450.09 163 446.5 163C442.91 163 440 160.09 440 156.5C440 152.91 442.91 150 446.5 150C450.09 150 453 152.91 453 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_44",
    d: "M493 156.5C493 160.09 490.09 163 486.5 163C482.91 163 480 160.09 480 156.5C480 152.91 482.91 150 486.5 150C490.09 150 493 152.91 493 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_45",
    d: "M533 156.5C533 160.09 530.09 163 526.5 163C522.91 163 520 160.09 520 156.5C520 152.91 522.91 150 526.5 150C530.09 150 533 152.91 533 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_45",
    d: "M573 156.5C573 160.09 570.09 163 566.5 163C562.91 163 560 160.09 560 156.5C560 152.91 562.91 150 566.5 150C570.09 150 573 152.91 573 156.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_46",
    d: "M13 186.5C13 190.09 10.0899 193 6.5 193C2.91015 193 0 190.09 0 186.5C0 182.91 2.91015 180 6.5 180C10.0899 180 13 182.91 13 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_46",
    d: "M53 186.5C53 190.09 50.0899 193 46.5 193C42.9101 193 40 190.09 40 186.5C40 182.91 42.9101 180 46.5 180C50.0899 180 53 182.91 53 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_47",
    d: "M93 186.5C93 190.09 90.0899 193 86.5 193C82.9101 193 80 190.09 80 186.5C80 182.91 82.9101 180 86.5 180C90.0899 180 93 182.91 93 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_47",
    d: "M133 186.5C133 190.09 130.09 193 126.5 193C122.91 193 120 190.09 120 186.5C120 182.91 122.91 180 126.5 180C130.09 180 133 182.91 133 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_48",
    d: "M173 186.5C173 190.09 170.09 193 166.5 193C162.91 193 160 190.09 160 186.5C160 182.91 162.91 180 166.5 180C170.09 180 173 182.91 173 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_48",
    d: "M213 186.5C213 190.09 210.09 193 206.5 193C202.91 193 200 190.09 200 186.5C200 182.91 202.91 180 206.5 180C210.09 180 213 182.91 213 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_49",
    d: "M253 186.5C253 190.09 250.09 193 246.5 193C242.91 193 240 190.09 240 186.5C240 182.91 242.91 180 246.5 180C250.09 180 253 182.91 253 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_49",
    d: "M293 186.5C293 190.09 290.09 193 286.5 193C282.91 193 280 190.09 280 186.5C280 182.91 282.91 180 286.5 180C290.09 180 293 182.91 293 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_50",
    d: "M333 186.5C333 190.09 330.09 193 326.5 193C322.91 193 320 190.09 320 186.5C320 182.91 322.91 180 326.5 180C330.09 180 333 182.91 333 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_50",
    d: "M373 186.5C373 190.09 370.09 193 366.5 193C362.91 193 360 190.09 360 186.5C360 182.91 362.91 180 366.5 180C370.09 180 373 182.91 373 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_51",
    d: "M413 186.5C413 190.09 410.09 193 406.5 193C402.91 193 400 190.09 400 186.5C400 182.91 402.91 180 406.5 180C410.09 180 413 182.91 413 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_51",
    d: "M453 186.5C453 190.09 450.09 193 446.5 193C442.91 193 440 190.09 440 186.5C440 182.91 442.91 180 446.5 180C450.09 180 453 182.91 453 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_52",
    d: "M493 186.5C493 190.09 490.09 193 486.5 193C482.91 193 480 190.09 480 186.5C480 182.91 482.91 180 486.5 180C490.09 180 493 182.91 493 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_52",
    d: "M533 186.5C533 190.09 530.09 193 526.5 193C522.91 193 520 190.09 520 186.5C520 182.91 522.91 180 526.5 180C530.09 180 533 182.91 533 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_53",
    d: "M573 186.5C573 190.09 570.09 193 566.5 193C562.91 193 560 190.09 560 186.5C560 182.91 562.91 180 566.5 180C570.09 180 573 182.91 573 186.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_53",
    d: "M13 216.5C13 220.09 10.0899 223 6.5 223C2.91015 223 0 220.09 0 216.5C0 212.91 2.91015 210 6.5 210C10.0899 210 13 212.91 13 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_54",
    d: "M53 216.5C53 220.09 50.0899 223 46.5 223C42.9101 223 40 220.09 40 216.5C40 212.91 42.9101 210 46.5 210C50.0899 210 53 212.91 53 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_54",
    d: "M93 216.5C93 220.09 90.0899 223 86.5 223C82.9101 223 80 220.09 80 216.5C80 212.91 82.9101 210 86.5 210C90.0899 210 93 212.91 93 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_55",
    d: "M133 216.5C133 220.09 130.09 223 126.5 223C122.91 223 120 220.09 120 216.5C120 212.91 122.91 210 126.5 210C130.09 210 133 212.91 133 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_55",
    d: "M173 216.5C173 220.09 170.09 223 166.5 223C162.91 223 160 220.09 160 216.5C160 212.91 162.91 210 166.5 210C170.09 210 173 212.91 173 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_56",
    d: "M213 216.5C213 220.09 210.09 223 206.5 223C202.91 223 200 220.09 200 216.5C200 212.91 202.91 210 206.5 210C210.09 210 213 212.91 213 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_56",
    d: "M253 216.5C253 220.09 250.09 223 246.5 223C242.91 223 240 220.09 240 216.5C240 212.91 242.91 210 246.5 210C250.09 210 253 212.91 253 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_57",
    d: "M293 216.5C293 220.09 290.09 223 286.5 223C282.91 223 280 220.09 280 216.5C280 212.91 282.91 210 286.5 210C290.09 210 293 212.91 293 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_57",
    d: "M333 216.5C333 220.09 330.09 223 326.5 223C322.91 223 320 220.09 320 216.5C320 212.91 322.91 210 326.5 210C330.09 210 333 212.91 333 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_58",
    d: "M373 216.5C373 220.09 370.09 223 366.5 223C362.91 223 360 220.09 360 216.5C360 212.91 362.91 210 366.5 210C370.09 210 373 212.91 373 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_58",
    d: "M413 216.5C413 220.09 410.09 223 406.5 223C402.91 223 400 220.09 400 216.5C400 212.91 402.91 210 406.5 210C410.09 210 413 212.91 413 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_59",
    d: "M453 216.5C453 220.09 450.09 223 446.5 223C442.91 223 440 220.09 440 216.5C440 212.91 442.91 210 446.5 210C450.09 210 453 212.91 453 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_59",
    d: "M493 216.5C493 220.09 490.09 223 486.5 223C482.91 223 480 220.09 480 216.5C480 212.91 482.91 210 486.5 210C490.09 210 493 212.91 493 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_60",
    d: "M533 216.5C533 220.09 530.09 223 526.5 223C522.91 223 520 220.09 520 216.5C520 212.91 522.91 210 526.5 210C530.09 210 533 212.91 533 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_60",
    d: "M573 216.5C573 220.09 570.09 223 566.5 223C562.91 223 560 220.09 560 216.5C560 212.91 562.91 210 566.5 210C570.09 210 573 212.91 573 216.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_61",
    d: "M13 246.5C13 250.09 10.0899 253 6.5 253C2.91015 253 0 250.09 0 246.5C0 242.91 2.91015 240 6.5 240C10.0899 240 13 242.91 13 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_61",
    d: "M53 246.5C53 250.09 50.0899 253 46.5 253C42.9101 253 40 250.09 40 246.5C40 242.91 42.9101 240 46.5 240C50.0899 240 53 242.91 53 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_62",
    d: "M93 246.5C93 250.09 90.0899 253 86.5 253C82.9101 253 80 250.09 80 246.5C80 242.91 82.9101 240 86.5 240C90.0899 240 93 242.91 93 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_62",
    d: "M133 246.5C133 250.09 130.09 253 126.5 253C122.91 253 120 250.09 120 246.5C120 242.91 122.91 240 126.5 240C130.09 240 133 242.91 133 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_63",
    d: "M173 246.5C173 250.09 170.09 253 166.5 253C162.91 253 160 250.09 160 246.5C160 242.91 162.91 240 166.5 240C170.09 240 173 242.91 173 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_63",
    d: "M213 246.5C213 250.09 210.09 253 206.5 253C202.91 253 200 250.09 200 246.5C200 242.91 202.91 240 206.5 240C210.09 240 213 242.91 213 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_64",
    d: "M253 246.5C253 250.09 250.09 253 246.5 253C242.91 253 240 250.09 240 246.5C240 242.91 242.91 240 246.5 240C250.09 240 253 242.91 253 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_64",
    d: "M293 246.5C293 250.09 290.09 253 286.5 253C282.91 253 280 250.09 280 246.5C280 242.91 282.91 240 286.5 240C290.09 240 293 242.91 293 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_65",
    d: "M333 246.5C333 250.09 330.09 253 326.5 253C322.91 253 320 250.09 320 246.5C320 242.91 322.91 240 326.5 240C330.09 240 333 242.91 333 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_65",
    d: "M373 246.5C373 250.09 370.09 253 366.5 253C362.91 253 360 250.09 360 246.5C360 242.91 362.91 240 366.5 240C370.09 240 373 242.91 373 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_66",
    d: "M413 246.5C413 250.09 410.09 253 406.5 253C402.91 253 400 250.09 400 246.5C400 242.91 402.91 240 406.5 240C410.09 240 413 242.91 413 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_66",
    d: "M453 246.5C453 250.09 450.09 253 446.5 253C442.91 253 440 250.09 440 246.5C440 242.91 442.91 240 446.5 240C450.09 240 453 242.91 453 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_67",
    d: "M493 246.5C493 250.09 490.09 253 486.5 253C482.91 253 480 250.09 480 246.5C480 242.91 482.91 240 486.5 240C490.09 240 493 242.91 493 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_67",
    d: "M533 246.5C533 250.09 530.09 253 526.5 253C522.91 253 520 250.09 520 246.5C520 242.91 522.91 240 526.5 240C530.09 240 533 242.91 533 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_68",
    d: "M573 246.5C573 250.09 570.09 253 566.5 253C562.91 253 560 250.09 560 246.5C560 242.91 562.91 240 566.5 240C570.09 240 573 242.91 573 246.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_68",
    d: "M13 276.5C13 280.09 10.0899 283 6.5 283C2.91015 283 0 280.09 0 276.5C0 272.91 2.91015 270 6.5 270C10.0899 270 13 272.91 13 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_69",
    d: "M53 276.5C53 280.09 50.0899 283 46.5 283C42.9101 283 40 280.09 40 276.5C40 272.91 42.9101 270 46.5 270C50.0899 270 53 272.91 53 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_69",
    d: "M93 276.5C93 280.09 90.0899 283 86.5 283C82.9101 283 80 280.09 80 276.5C80 272.91 82.9101 270 86.5 270C90.0899 270 93 272.91 93 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_70",
    d: "M133 276.5C133 280.09 130.09 283 126.5 283C122.91 283 120 280.09 120 276.5C120 272.91 122.91 270 126.5 270C130.09 270 133 272.91 133 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_70",
    d: "M173 276.5C173 280.09 170.09 283 166.5 283C162.91 283 160 280.09 160 276.5C160 272.91 162.91 270 166.5 270C170.09 270 173 272.91 173 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_71",
    d: "M213 276.5C213 280.09 210.09 283 206.5 283C202.91 283 200 280.09 200 276.5C200 272.91 202.91 270 206.5 270C210.09 270 213 272.91 213 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_71",
    d: "M253 276.5C253 280.09 250.09 283 246.5 283C242.91 283 240 280.09 240 276.5C240 272.91 242.91 270 246.5 270C250.09 270 253 272.91 253 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_72",
    d: "M293 276.5C293 280.09 290.09 283 286.5 283C282.91 283 280 280.09 280 276.5C280 272.91 282.91 270 286.5 270C290.09 270 293 272.91 293 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_72",
    d: "M333 276.5C333 280.09 330.09 283 326.5 283C322.91 283 320 280.09 320 276.5C320 272.91 322.91 270 326.5 270C330.09 270 333 272.91 333 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_73",
    d: "M373 276.5C373 280.09 370.09 283 366.5 283C362.91 283 360 280.09 360 276.5C360 272.91 362.91 270 366.5 270C370.09 270 373 272.91 373 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_73",
    d: "M413 276.5C413 280.09 410.09 283 406.5 283C402.91 283 400 280.09 400 276.5C400 272.91 402.91 270 406.5 270C410.09 270 413 272.91 413 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_74",
    d: "M453 276.5C453 280.09 450.09 283 446.5 283C442.91 283 440 280.09 440 276.5C440 272.91 442.91 270 446.5 270C450.09 270 453 272.91 453 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_74",
    d: "M493 276.5C493 280.09 490.09 283 486.5 283C482.91 283 480 280.09 480 276.5C480 272.91 482.91 270 486.5 270C490.09 270 493 272.91 493 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_75",
    d: "M533 276.5C533 280.09 530.09 283 526.5 283C522.91 283 520 280.09 520 276.5C520 272.91 522.91 270 526.5 270C530.09 270 533 272.91 533 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_75",
    d: "M573 276.5C573 280.09 570.09 283 566.5 283C562.91 283 560 280.09 560 276.5C560 272.91 562.91 270 566.5 270C570.09 270 573 272.91 573 276.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_76",
    d: "M13 306.5C13 310.09 10.0899 313 6.5 313C2.91015 313 0 310.09 0 306.5C0 302.91 2.91015 300 6.5 300C10.0899 300 13 302.91 13 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_76",
    d: "M53 306.5C53 310.09 50.0899 313 46.5 313C42.9101 313 40 310.09 40 306.5C40 302.91 42.9101 300 46.5 300C50.0899 300 53 302.91 53 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_77",
    d: "M93 306.5C93 310.09 90.0899 313 86.5 313C82.9101 313 80 310.09 80 306.5C80 302.91 82.9101 300 86.5 300C90.0899 300 93 302.91 93 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_77",
    d: "M133 306.5C133 310.09 130.09 313 126.5 313C122.91 313 120 310.09 120 306.5C120 302.91 122.91 300 126.5 300C130.09 300 133 302.91 133 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_78",
    d: "M173 306.5C173 310.09 170.09 313 166.5 313C162.91 313 160 310.09 160 306.5C160 302.91 162.91 300 166.5 300C170.09 300 173 302.91 173 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_78",
    d: "M213 306.5C213 310.09 210.09 313 206.5 313C202.91 313 200 310.09 200 306.5C200 302.91 202.91 300 206.5 300C210.09 300 213 302.91 213 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_79",
    d: "M253 306.5C253 310.09 250.09 313 246.5 313C242.91 313 240 310.09 240 306.5C240 302.91 242.91 300 246.5 300C250.09 300 253 302.91 253 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_79",
    d: "M293 306.5C293 310.09 290.09 313 286.5 313C282.91 313 280 310.09 280 306.5C280 302.91 282.91 300 286.5 300C290.09 300 293 302.91 293 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_80",
    d: "M333 306.5C333 310.09 330.09 313 326.5 313C322.91 313 320 310.09 320 306.5C320 302.91 322.91 300 326.5 300C330.09 300 333 302.91 333 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_80",
    d: "M373 306.5C373 310.09 370.09 313 366.5 313C362.91 313 360 310.09 360 306.5C360 302.91 362.91 300 366.5 300C370.09 300 373 302.91 373 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_81",
    d: "M413 306.5C413 310.09 410.09 313 406.5 313C402.91 313 400 310.09 400 306.5C400 302.91 402.91 300 406.5 300C410.09 300 413 302.91 413 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_81",
    d: "M453 306.5C453 310.09 450.09 313 446.5 313C442.91 313 440 310.09 440 306.5C440 302.91 442.91 300 446.5 300C450.09 300 453 302.91 453 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_82",
    d: "M493 306.5C493 310.09 490.09 313 486.5 313C482.91 313 480 310.09 480 306.5C480 302.91 482.91 300 486.5 300C490.09 300 493 302.91 493 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle2_82",
    d: "M533 306.5C533 310.09 530.09 313 526.5 313C522.91 313 520 310.09 520 306.5C520 302.91 522.91 300 526.5 300C530.09 300 533 302.91 533 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle1_83",
    d: "M573 306.5C573 310.09 570.09 313 566.5 313C562.91 313 560 310.09 560 306.5C560 302.91 562.91 300 566.5 300C570.09 300 573 302.91 573 306.5Z",
    fill: "#011B25",
    fillOpacity: 0.62
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAbstract);
export default __webpack_public_path__ + "static/media/circle-abstract.86f51a13c6d01809ddf1a7a08ef51701.svg";
export { ForwardRef as ReactComponent };